class Tab {
    constructor(element) {
        if (element.dataset.tabsInit) return;

        this.wrapper = element;
        this._init();
    }

    _init = () => {
        this.wrapper.addEventListener('click', this._wrapperHandler);

        this.wrapper.setAttribute('data-tabs-init', '')
    }

    _wrapperHandler = (e) => {
        const target = e.target.closest('[data-tab-trigger]:not(.active)');

        if (!target) return;

        e.preventDefault();

        const prevBtn = this.wrapper.querySelector('[data-tab-trigger].active');
        const prevContent = this.wrapper.querySelector('[data-tab-content].active');

        prevBtn && prevBtn.classList.remove('active');
        prevContent && prevContent.classList.remove('active');

        const currentContent = this.wrapper.querySelector(`[data-tab-content="${target.dataset.tabTrigger}"]`);

        target.classList.add('active');
        currentContent.classList.add('active');
    }
}
